/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import ToggleSwitch from "../common/ToggleSwitch";
import MultiSelect from "../common/MultiSelect";
// import { components } from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { getRoleListing } from '../store/slices/RoleUser';
import ReactSelect from "../common/ReactSelect";
import { getMasterConfig } from '../store/slices/common';
import { USER_EMAIL_REGEX, USER_NAME_VALIDATION, USERLIST_MOBILE_REGEX, USERLIST_PASSWORD_REGEX,COUNTRY_CODE,APP_COUNTRY } from '../../src/config/constant';
import { useLanguage } from "../../src/context/LanguageContext";


// const { ValueContainer, Placeholder } = components;

// const CustomValueContainer = ({ children, ...props }: any) => {
//     return (
//         <ValueContainer {...props}>
//             <Placeholder {...props} isFocused={props.isFocused}>
//                 {props.selectProps.placeholder}
//             </Placeholder>
//             {React.Children.map(children, child =>
//                 child && child.type !== Placeholder ? child : null
//             )}
//         </ValueContainer>
//     );
// };


function UserListPopup(props: any) {
    const dispatch: any = useDispatch();
    let { showUserPopup, userEditPopup, role_list, userDetails } = props;
     // eslint-disable-next-line
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    let [userList, setUserList] = useState<any>([]);
    const {translations} = useLanguage();

    let [assigned_feature_list, setAssignedFeatureList] = useState<any>([]);
    let [formData, setFormData] = useState<any>({ ...userDetails || {} });
    let [errors, setErrors] = useState<any>({});
    let [changeRole , setChangeRole] = useState<any>([])
    const mobile_regex = USERLIST_MOBILE_REGEX;
    const email_regex = USER_EMAIL_REGEX
    const password_regex = USERLIST_PASSWORD_REGEX;

    const commonState = useSelector((state: any) => state.common);

    // add source
    let assignSource = (COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH) ? commonState?.common?.lead_types ?? [] : commonState?.common?.assigned_source ?? [];
    let subAssigneSource = commonState?.common?.sub_lead_types??[];
    let leadSource = commonState?.common?.lead_sources??[];
    let leadSubsource = commonState?.common?.sub_lead_sources??[];

    // const toggleDropdown = () => {
        
    //     setIsDropdownOpen(!isDropdownOpen);
    // };
   
    useEffect(() => {
        if (Object.keys(commonState.common).length === 0) {
            dispatch(getMasterConfig());
        }
        // eslint-disable-next-line
    }, []);



    const handleChange = async (key: any, event: any) => {
        let value: any = '';
        let target = event?.target;
    
        if (key === 'status') {
            value = formData.status === 1 ? 0 : 1;
        } else if (event instanceof Array) {
            value = event.map((e: any) => e.value);
        } else if (target) {
            value = target.value;
        } else if (event) {
            value = event.value;
        } 
        errors[key] = '';
        setErrors({ ...errors });
    
        // Assign Source
        if (key === 'assign_source') {
            setFormData({ ...formData, assign_source: value });
            return;
        }
    
        // Sub Assign Source (merged into assign_source)
        if (key === 'assign_sub_source') {
            const existing = formData.assign_source || [];
            const cleaned = existing.filter(
                (id: number) => !subAssigneSource.some((sub: any) => sub.value === id)
            );
            const newSubValues = event.map((e: any) => e.value);
            setFormData({ ...formData, assign_source: [...cleaned, ...newSubValues] });
            return;
        }
    
        // Lead Source
        if (key === 'assign_lead_type') {
            setFormData({ ...formData, assign_lead_type: value });
            return;
        }
    
        // Sub Lead Source (merged into assign_lead_type)
        if (key === 'assign_sub_lead_type') {
            const existing = formData.assign_lead_type || [];
            const cleaned = existing.filter(
                (id: number) => !leadSubsource.some((sub: any) => sub.value === id)
            );
            const newSubValues = event.map((e: any) => e.value);
            setFormData({ ...formData, assign_lead_type: [...cleaned, ...newSubValues] });
            return;
        }
    
        //  Generic handler
        if (key === 'reportee_role_id') {
            formData.reportee_id = '';
        }
    
        if (key === 'assigned_role') {
            value = event?.value; 
            if (!changeRole.includes(event)) {
                setChangeRole([...changeRole, event]);
            }
        }
        const updatedForm = { ...formData, [key]: value };
        setFormData(updatedForm);
    };
    

    const isFormValid = async (formData: any) => {
        let isValid = true;
        if (!formData.firstname || formData.firstname === '') {
            errors['firstname'] = "This Field is Required";
            isValid = false;
        } else if (formData && formData.firstname && (formData.firstname.split('').length < USER_NAME_VALIDATION['min'] || formData.firstname.split('').length > USER_NAME_VALIDATION['max'])) {
            errors['firstname'] = "User Name should be between 3 and 30";
            isValid = false;
        }
        if (!formData.lastname || formData.lastname === '') {
            errors['lastname'] = "This Field is Required";
            isValid = false;
        } else if (formData && formData.lastname && (formData.lastname.split('').length < USER_NAME_VALIDATION['min'] || formData.lastname.split('').length > USER_NAME_VALIDATION['max'])) {
            errors['lastname'] = "User Name should be between 3 and 30";
            isValid = false;
        }
        if (!formData.mobile || formData.mobile === '') {
            errors['mobile'] = "Mobile No is required";
            isValid = false;
        } else if (!mobile_regex.test(formData.mobile)) {
            errors['mobile'] = 'Invalid mobile no.';
            isValid = false;
        }
        if (!formData.email || formData.email === '') {
            errors['email'] = "Email is required";
            isValid = false;
        } else if (!email_regex.test(formData.email)) {
            errors['email'] = "Email is not valid";
            isValid = false;
        }
        if (formData.password && !password_regex.test(formData.password)) {
            errors['password'] = 'Password should be atleast 8 character with 1 special char,1 Uppercase,1 lowercase and 1 digit';
            isValid = false;
        }
        if (!formData.reportee_id || formData.reportee_id === '') {
            errors['reportee_id'] = "Reporting user is required";
            isValid = false;
        }

        //assign_source
        if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH){
            if (!formData.assign_source || formData?.assign_source.length === 0) {
                errors['assign_source'] = 'Assign source is required';
                isValid = false;
            }
        }

        // Sub Assign Source validation
        const showSubAssignSource = subAssigneSource.some((sub: any) =>
            (formData.assign_source || []).includes(sub.lead_type_id)
        );

        // Check if any selected assign_source ID is a sub source
        const selectedSubAssignSources = (formData.assign_source || []).filter((id: number) =>
            subAssigneSource.some((sub: any) => sub.value === id)
        );


        if (showSubAssignSource && selectedSubAssignSources.length === 0) {
            errors['assign_sub_source'] = 'Sub Assign Source is required';
            isValid = false;
        }
        if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH){
            if (!formData.assign_lead_type || formData?.assign_lead_type.length === 0) {
                errors['assign_lead_type'] = 'Lead source is required';
                isValid = false;
            }
    
            const showSubLeadSource = leadSubsource.some((sub: any) =>
                (formData.assign_lead_type || []).includes(sub.lead_source_id)
            );
    
            const selectedSubLeadSources = (formData.assign_lead_type || []).filter((id: number) =>
                leadSubsource.some((sub: any) => sub.value === id)
            );
           
            if (showSubLeadSource && selectedSubLeadSources.length === 0) {
                errors['assign_sub_lead_type'] = 'Sub Lead Source is required';
                isValid = false;
            }
        }

        
        setErrors({ ...errors });
        return isValid;

    }


    const handleSubmit = async (e: any) => {
        e.preventDefault();
        let formData = await getFormData();
        //In assigned Role to check any changes make or not 
        // let userDetailsArray = props?.userDetails?.assigned_role_ids?.split(',').map(Number);
        // let isMatched = userDetailsArray?.every((value: any) => formData?.assigned_role.includes(value)) &&
        //     formData?.assigned_role?.every((value:any) => userDetailsArray.includes(value));
        // match name and status is match or not with updated value
        const isNameStatusMatch = userDetails?.name === formData?.name && userDetails?.status === formData?.status;
       
        if (await isFormValid(formData)) {
            props.setLoading(true);
            // if role change then it add in payload
            // if (changeRole && changeRole.length > 0 && isMatched === false) {
            //     formData.changeRole = changeRole
            // }
            if (isNameStatusMatch === false) {
                formData.changeValue = true;
            }
            
            dispatch(getRoleListing.saveUserData(formData)).then((res: any) => {
                props.setLoading(false);
                if (res && res.status === 200) {
                    toast.success(res.message);
                    setFormData({});
                    props.userEditPopup(false, {});
                    props.getUserManageListDetails({});
                    props.setActiveTab(1)
                }
            }).catch((err: Error) => {
                props.setLoading(false);
            })
        }
     props.setSearchText('');
    }

    const getUserList = async () => {
        dispatch(getRoleListing.getUserManagementList({ isPaginationApply: false })).then((res: any) => {
            if (res && res.status === 200) {
                let userList = [];
                userList = (res.data && res.data.length && formData) ?
                    res.data.map((e: any) => {
                        let isChecked = formData.reportee_id ? formData.reportee_id === e.id : false;
                        return {
                            value: e.id,
                            label: e.firstname+ ' ' +e.lastname,
                            isChecked: isChecked,
                            assigned_role: e.assigned_role_ids ? e.assigned_role_ids.split(',') : []
                        }
                    }) : [];
                let assignedRole = [];
                if (formData.assigned_role_ids) {
                    assignedRole = formData.assigned_role_ids.split(',');
                    assignedRole = assignedRole.map((id: any) => Number(id));
                }
                formData.vertical_id = 1;
                formData.assigned_role = assignedRole;
                setFormData({ ...formData });
                setUserList([...userList]);
            }
        })
    };

    const getFormData = async () => {
        let postData: any = {};
        
        if (formData && formData.id) postData['id'] = formData.id;
        if (formData && formData.firstname) postData['firstname'] = formData.firstname?.replace(/\s+/g,' ').trim();
        if (formData && formData.lastname) postData['lastname'] = formData.lastname?.replace(/\s+/g,' ').trim();
        if (formData && formData.email) postData['email'] = formData.email?.replace(/\s+/g,' ').trim();
        if (formData && formData.password) postData['password'] = formData.password ;
        if (formData && formData.mobile) postData['mobile'] = formData.mobile;
        if (formData && formData.assigned_role) postData['assigned_role'] = +formData?.assigned_role;
        if (formData && formData.status !== undefined) postData['status'] = formData.status;
        if (formData && formData.reportee_id) postData['reportee_id'] = formData.reportee_id;
        if (formData && formData.reportee_role_id) postData['reportee_role_id'] = formData.reportee_role_id;

        // combine assign and sub source 
        if (formData && formData.assign_source) postData['assign_source'] = [...(formData.assign_source || []),...(formData.assign_sub_source || []) ];
        if (formData && formData.assign_lead_type) postData['assign_lead_type'] = [...(formData.assign_lead_type || []),...(formData.assign_sub_lead_type || []) ];
        
        return postData;
    }


    // useEffect(() => {
    //     if (
    //         showUserPopup &&
    //         userDetails &&
    //         assignSource.length &&
    //         leadSource.length
            
    //     ) {
    //         getAsyncData();
    //     }
    // }, [showUserPopup,userDetails, assignSource, subAssigneSource, leadSource, leadSubsource]);
    useEffect(() => {
        if (showUserPopup) {
          getAsyncData(); // always call when popup opens
        }
        // eslint-disable-next-line
      }, [showUserPopup]);


    const getAsyncData = async () => {
        await getUserList();
        // if (userDetails) {
        //     setFormData({
        //         ...userDetails,
        //     });
        // }

        let updatedData: any = { ...userDetails };
       
        if (userDetails && userDetails.assigned_feature_names) {
            let assignedFeatures = userDetails.assigned_feature_names.split(",");
            setAssignedFeatureList([...assignedFeatures]);
        }
        
        
        setFormData(updatedData);
    }
   
    let user_list : any = [];

    if (formData && formData.reportee_role_id) {
        user_list = userList.filter((e: any) => {
            return e.assigned_role?.includes(String(formData.reportee_role_id));
        })
    }
    if (userDetails && userDetails.id && user_list?.length) {
        user_list = user_list.filter((e: any) => e.value !== userDetails.id);
    }

    return (
        <React.Fragment>
            {
              showUserPopup?
                <div className="edit-role-outer user-list-outer edit-user-popup-bx">
                    <div className="edit-role-main">
                        <h2>{translations.RuleEngine?.['Edit_User'] || translations.commonMsg?.loading}</h2>
                        <a className="close-icn"  onClick={() => userEditPopup(false)}><i className="ic-clearclose"></i></a>
                      
                            <div className="row">
                                <div className=" role-status-outer w-100">
                                    <div className="col-md-6">
                                        <fieldset className="">
                                            <div className="material">
                                                <input id="" type="text" placeholder=" " name="First Name" className="form-input" onChange={(e: any) => handleChange('firstname', e)} value={formData.firstname || ''} />
                                                <label data-label={translations.RuleEngine?.['firstname'] || translations.commonMsg?.loading} className="form-label"></label>
                                                <span className="error-txt">
                                                    {errors.firstname || ""}
                                                </span>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className="col-md-6">
                                        <fieldset className="">
                                            <div className="material">
                                                <input id="" type="text" placeholder=" " name="Last Name" className="form-input" onChange={(e: any) => handleChange('lastname', e)} value={formData.lastname || ''} />
                                                <label data-label={translations.RuleEngine?.['lastname'] || translations.commonMsg?.loading} className="form-label"></label>
                                                <span className="error-txt">
                                                    {errors.lastname || ""}
                                                </span>
                                            </div>
                                        </fieldset>
                                    </div>
                                    
                                </div>
                                
                                <div className="col-md-6">
                                    <fieldset className="">
                                        <div className="material">
                                            <input id="mobileNo" type="text" placeholder=" " name="MobileNumber" className="form-input" value={formData.mobile || ''} disabled={true} />
                                            <label data-label={translations.RuleEngine?.['Mobile Number'] || translations.commonMsg?.loading} className="form-label"></label>
                                            <span className="error-txt">
                                                {errors.mobile || ""}
                                            </span>
                                        </div>
                                    </fieldset>
                                </div>

                                <div className="col-md-6">
                                    <fieldset className=" password-txt-msg">
                                        <div className="material">
                                            <input id="password" type="text" placeholder=" " name="password" className="form-input" onChange={(e: any) => handleChange('password', e)} />
                                            <label data-label={translations.RuleEngine?.['Password'] || translations.commonMsg?.loading} className="form-label"></label>
                                            <span className="error-txt">
                                                {errors.password || ""}
                                            </span>
                                        </div>
                                    </fieldset>

                                </div>
                                
                                <div className="col-md-6">
                                    <fieldset className="">
                                        <div className="material">
                                            <input id="email" type="text" placeholder=" " name="email" className="form-input" value={formData.email || ''} disabled={true} />
                                            <label data-label={translations.RuleEngine?.['Email'] || translations.commonMsg?.loading} className="form-label"></label>
                                            <span className="error-txt">
                                                {errors.email || ""}
                                            </span>
                                        </div>
                                    </fieldset>
                                </div>
                                
                                <div className="col-md-6">
                                    <fieldset className="">
                                        <div className="material">
                                            <ReactSelect
                                                id="assigned_role"
                                                value={
                                                    role_list?.find((e: any) => e.value === +formData.assigned_role) || null
                                                }
                                                //value={role_list?.find((e: any) => e.value === formData.assigned_role)}
                                                handleChange={(e: any, fieldKey: string) => handleChange(fieldKey, e)}
                                                options={role_list}
                                                placeholder={"Add Role"}
                                                fieldKey="assigned_role"
                                            />
                                        </div>
                                    </fieldset>
                                </div>                                
                                <div className="col-md-6">
                                    <div className="m-b-30">
                                        <ReactSelect options={role_list} value={
                                            formData &&
                                            role_list.filter(
                                                (v: any) =>
                                                    v.value === Number(formData.reportee_role_id)
                                            )
                                        } handleChange={(e: any, fieldKey: string) => handleChange(fieldKey, e)} placeholder={translations.RuleEngine?.['Reporting Role'] || translations.commonMsg?.loading} fieldKey="reportee_role_id" key="reportee_role_id" errorField={errors.reportee_role_id} />
                                    </div>

                                </div>
                                
                                <div className="col-md-6">
                                    <ReactSelect
                                        options={user_list}
                                        value={
                                            formData &&
                                            user_list.filter(
                                                (v: any) =>
                                                    v.value === formData.reportee_id
                                            )
                                        }
                                        handleChange={(e: any, fieldKey: string) => handleChange(fieldKey, e)} placeholder={translations.RuleEngine?.['Reporting Name'] || translations.commonMsg?.loading} fieldKey="reportee_id" key="reportee_id" errorField={errors.reportee_id}
                                    />

                                </div>

                                {
                                    isDropdownOpen && assigned_feature_list.length > 0 &&
                                    <div className="col-md-12 userList-feature-assign">
                                        <ul>
                                            {
                                                assigned_feature_list.map((item: any) => (
                                                    <li>{item}
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                }

                                {/*  Assign Source */}
                                <div className="col-md-6">
                                    <fieldset className="single-select">
                                        <div className="material">
                                            <MultiSelect
                                                isSelectAll={true}
                                                options={assignSource}
                                                placeholder={translations.RuleEngine?.['Assign Source'] || translations.commonMsg?.loading}
                                                value={
                                                    (assignSource instanceof Array &&
                                                        formData.assign_source &&
                                                        assignSource.filter((e) =>
                                                            [...(formData.assign_source instanceof Array ? formData.assign_source : [])].includes(e.value)
                                                        )) || []
                                                }
                                                onChange={(e: any) => handleChange('assign_source', e)}
                                                className="react-select"
                                                classNamePrefix="react-select"
                                            
                                                                                           />
                                            <span className="error-txt">
                                                {errors.assign_source || ""}
                                            </span>
                                        </div>
                                    </fieldset>
                                </div>


                                {/*  SHOW Sub Source ONLY if it has value */}
                                {subAssigneSource.some((item: any) => formData?.assign_source.includes(item?.lead_type_id)) &&
                                    <div className="col-md-6">
                                        <fieldset className="single-select">
                                            <div className="material">
                                                <MultiSelect
                                                    isSelectAll={true}
                                                    options={subAssigneSource}
                                                    placeholder={translations.RuleEngine?.['Sub Source'] || translations.commonMsg?.loading}
                                                    value={
                                                        (subAssigneSource instanceof Array &&
                                                            formData.assign_source &&
                                                            subAssigneSource.filter((e) =>
                                                                [...(formData.assign_source instanceof Array ? formData.assign_source : [])].includes(e.value)
                                                            )) || []
                                                    }
                                                                                                    className="react-select"
                                                classNamePrefix="react-select"
                                                    onChange={(e: any) => handleChange('assign_sub_source', e)}
                                                />

                                                <span className="error-txt">
                                                    {errors.assign_sub_source || ""}
                                                </span>
                                            </div>
                                        </fieldset>
                                    </div>

                                }

                                {
                                    COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH && 
                                    <>
                                        {/* Lead Source */}
                                        <div className="col-md-6">
                                            <fieldset className="single-select">
                                                <div className="material">
                                                    <MultiSelect
                                                        isSelectAll={true}
                                                        options={leadSource}
                                                        placeholder={translations.RuleEngine?.['Lead Source'] || translations.commonMsg?.loading}
                                                        value={
                                                            (leadSource instanceof Array &&
                                                                formData.assign_lead_type &&
                                                                leadSource.filter((e) =>
                                                                    [...(formData.assign_lead_type instanceof Array ? formData.assign_lead_type : [])].includes(e.value)
                                                                )) || []
                                                        }
                                                        onChange={(e: any) => handleChange('assign_lead_type', e)}
                                                        className="react-select"
                                                        classNamePrefix="react-select"
                                                    />
                                                    <span className="error-txt">
                                                        {errors.assign_lead_type || ""}
                                                    </span>
                                                </div>
                                            </fieldset>
                                        </div>

                                        {leadSubsource.some((item: any) => formData?.assign_lead_type.includes(item?.lead_source_id)) &&

                                            <div className="col-md-6">
                                                <fieldset className="single-select">
                                                    <div className="material">
                                                        <MultiSelect
                                                            isSelectAll={true}
                                                            options={leadSubsource}
                                                            placeholder={translations.RuleEngine?.['Lead Sub Source'] || translations.commonMsg?.loading}
                                                            value={
                                                                (leadSubsource instanceof Array &&
                                                                    formData.assign_lead_type &&
                                                                    leadSubsource.filter((e) =>
                                                                        [...(formData.assign_lead_type instanceof Array ? formData.assign_lead_type : [])].includes(e.value)
                                                                    )) || []
                                                            }
                                                        className="react-select"
                                                        classNamePrefix="react-select"
                                                            onChange={(e: any) => handleChange('assign_sub_lead_type', e)}
                                                        />
                                                        <span className="error-txt">
                                                            {errors.assign_sub_lead_type || ""}
                                                        </span>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        }
                                    </>
                                }

                                <div className="col-md-6">
                                    <fieldset className="">
                                        <div className="material status-btn" onClick={(e) => handleChange('status', e)}>
                                            <ToggleSwitch checked={String(formData.status) === "1" ? true : false} />
                                            <div className="status-txt">{String(formData.status) === "1" ? translations.commonMsg?.['active'] || translations.commonMsg?.loading : translations.commonMsg?.['in_active'] || translations.commonMsg?.loading}</div>
                                        </div>
                                    </fieldset>
                                </div>
                                {/* {
                                HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['task_role_assignment'], accessType: 'edit' }) && */}
                                <div className="col-md-12">
                                    <button className="btn-primary m-md-t" onClick={(e: any) => handleSubmit(e)}>{translations.commonMsg?.['saveChanges'] || translations.commonMsg?.loading}</button>
                                </div>
                                {/* } */}
                            </div>
                        
                    </div>
                </div>
                :null
            }
        </React.Fragment>
    )
}
export default UserListPopup;